import { isometricSettings } from '../services/mapIsometricSettings'

export default {
  data () { return { editorView: 'GRID' } },
  computed: {
    isIsometricEditor () { return this.editorView === 'ISOMETRIC' },
    isometricAppearance () { return isometricSettings(this.sceneSettings) }
  },
  watch: { editorView () { this.$nextTick(() => { this.bindMapViewport(); this.resetMapView() }) } },
  methods: {
    setEditorView (view) {
      if (this.editorView === view) return
      this.stopSceneResize(true)
      if (this.mapPanStart) this.endMapPan({ pointerId: this.mapPanStart.id })
      this.editorView = view
      this.$nextTick(() => { this.bindMapViewport(); this.resetMapView() })
    },
    setIsometricAppearance (key, value) {
      if (this.readOnly || this.saving) return
      this.sceneSettings = { ...this.sceneSettings, isometric: { ...this.isometricAppearance, ...this.sceneSettings.isometric, [key]: value } }
    },
    openIsometricSection (key) {
      if (key === 'cells' || key === 'points' || key === 'schemes') { this.openEditorTab(key); return }
      this.openEditorTab('layers'); this.$nextTick(() => this.$refs.sceneConfig?.switchSection(key))
    },
    selectIsoScene (hit) {
      if (!hit || this.saving || this.loading || this.templateApplying || this.mapPanMode || !this.checkPointApplied()) return
      const config = this.$refs.sceneConfig
      if (!config) return
      if (hit.kind === config.section && config.editState.preview?.id === hit.item.id) return
      const selected = config.selectMapItem(hit.kind, hit.item._automaticSource || hit.item, hit.index, hit.automatic || !!hit.item._automaticSource)
      const afterSelect = accepted => { if (accepted && !this._isDestroyed) {
        this.cancelDraw(); this.pointPicking = false; this.schemeSelecting = false; this.mapConfigCollapsed = false
        this.openEditorTab('layers')
        this.$nextTick(() => { const pane = this.$refs.editorScroll, panel = this.$el.querySelector('.map-scene-config'); if (pane && panel) pane.scrollTop += panel.getBoundingClientRect().top - pane.getBoundingClientRect().top })
      } }
      if (selected && typeof selected.then === 'function') selected.then(afterSelect); else afterSelect(selected)
    },
    zoomIsometricAt (event, point) {
      if (this.sceneDrag || this.mapPanning) return
      const delta = Math.max(-200, Math.min(200, event.deltaY * (event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? 200 : 1)))
      this.mapZoom = Math.max(.1, Math.min(4, this.mapZoom * Math.exp(-delta * .0015)))
      const x = event.clientX, y = event.clientY
      this.$nextTick(() => this.$refs.isoEditor?.anchorWorld(point, x, y))
    }
  }
}
